module.exports = __webpack_public_path__ + "resources/image_fail_ver.e2fbe4946902f04c.png";